<template>
    <div class="d-flex flex-wrap gap-4 side-nav-padding">
        <template v-for="material in materials">
            <div :key="material.id" class="image-editor-card-primary cursor-pointer flex-grow-1 cutline-card user-select-none" :class="{'selected' : store.material_id === material.id}" @click="setMaterial($event)" :data-value="material.id">
                <img :src="material.thumb" class="card-icon filter-none mb-2">
                <p class="fs-5">{{$trans(`storefront::image_editor.${material.title}`)}}</p>
            </div>
        </template>
    </div>
</template>

<script>
import {useImageEditorStore} from "../store";
import {materials} from "../js/materialService";
import {functions} from "../imageEditor";

export default {
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
            materials: materials,
        }
    },
    methods: {
        setMaterial (event) {
            let value = event.target.closest('.image-editor-card-primary').getAttribute('data-value');
            functions.setMaterial(parseInt(value));
        },
    }
}
</script>
